import { AxiosError } from 'axios';
import { apiClient } from '@api/client';

export interface WarehouseMenuBadgeDTO {
  type: string;
  value: number;
  status?: string;
}

export interface WarehouseMenuItemDTO {
  key: string;
  labelKey?: string;
  label?: string;
  path: string;
  external?: boolean;
  icon?: string;
  badge?: WarehouseMenuBadgeDTO;
  children?: WarehouseMenuItemDTO[];
  category?: string;
  customId?: number;
}

export interface WarehouseMenuDTO {
  key: string;
  labelKey: string;
  icon: string;
  items: WarehouseMenuItemDTO[];
}

export interface TaskMenuStatsDTO {
  active?: number;
  overdue?: number;
}

export interface TaskMenuBadgeDTO {
  type: string;
  value: number;
  status?: string;
}

export interface TaskMenuItemDTO {
  key: string;
  label?: string;
  labelKey?: string;
  path?: string;
  external?: boolean;
  taskTypeId?: number;
  canCreate?: boolean;
  badge?: TaskMenuBadgeDTO;
  children?: TaskMenuItemDTO[];
  category?: 'base' | 'type' | 'group' | 'custom';
  stats?: TaskMenuStatsDTO;
  customId?: number;
  icon?: string;
}

export interface TaskMenuDTO {
  key: string;
  labelKey: string;
  icon: string;
  items: TaskMenuItemDTO[];
}

function isClientError(error: unknown): error is AxiosError {
  if (error instanceof AxiosError) {
    const status = error.response?.status ?? 0;
    return status >= 400 && status < 500;
  }

  return false;
}

export async function fetchWarehouseMenu(): Promise<WarehouseMenuDTO | null> {
  try {
    const { data } = await apiClient.get<WarehouseMenuDTO>('/menu/warehouse');
    return data;
  } catch (error) {
    if (isClientError(error)) {
      console.warn(
        '[menu] Warehouse menu endpoint returned client error. Dynamic menu will be hidden.',
        error.response?.status
      );
      return null;
    }

    throw error;
  }
}

export async function fetchTaskMenu(): Promise<TaskMenuDTO | null> {
  try {
    const { data } = await apiClient.get<TaskMenuDTO>('/tasks/menu');
    return data;
  } catch (error) {
    if (isClientError(error)) {
      console.warn(
        '[menu] Task menu endpoint returned client error. Dynamic menu will be hidden.',
        error.response?.status
      );
      return null;
    }

    throw error;
  }
}
